import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { CellClassParams } from 'ag-grid-community';
import * as styles from './styles.scss';
import i18next from 'i18next';

const CustomTooltip = (params: CellClassParams) => {
  return (
    <div className={styles.CustomTooltip}>
      <span>{params.value}</span>
      {params.data.symbol !== i18next.t('TOTAL 2') && params.data.isBuyin && (
        <OverlayTrigger
          key={params.rowIndex}
          placement="top"
          overlay={
            <Tooltip id={`tooltip-${params.rowIndex}`}>
              {i18next.t('This symbol available for Buy-In order type')}
            </Tooltip>
          }
        >
          <span className={styles.IconTooltip}>*</span>
        </OverlayTrigger>
      )}
    </div>
  );
};

export default CustomTooltip;



// WEBPACK FOOTER //
// ./src/components/areas/Account/Portfolio/CustomTooltip/index.tsx